import React from 'react'
import { IconProps } from './types'

export const IconOutlineFingerPrint = ({
	size = '1em',
	...props
}: IconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			fill="none"
			viewBox="0 0 24 24"
			focusable="false"
			{...props}
		>
			<path
				fill="currentColor"
				fillRule="evenodd"
				d="M7.5 3.205A9 9 0 0 1 21 11c0 2.567-.358 5.051-1.029 7.406a1 1 0 0 1-1.923-.548C18.668 15.68 19 13.38 19 11A7 7 0 0 0 8.5 4.936a1 1 0 1 1-1-1.731Zm-1.93 2.93A1 1 0 0 1 5.936 7.5 6.963 6.963 0 0 0 5 11c0 1.72-.395 3.35-1.1 4.801a1 1 0 0 1-1.8-.874A8.96 8.96 0 0 0 3 11c0-1.638.438-3.176 1.205-4.5a1 1 0 0 1 1.366-.366ZM7 11a5 5 0 0 1 10 0 23 23 0 0 1-.213 3.135 1 1 0 0 1-1.981-.27c.128-.937.194-1.893.194-2.865a3 3 0 1 0-6 0 14.916 14.916 0 0 1-2.333 8.041 1 1 0 1 1-1.72-1.021l.068-.111.846.532-.846-.532A12.916 12.916 0 0 0 7 11Zm5-1a1 1 0 0 1 1 1 18.92 18.92 0 0 1-2.906 10.104A1 1 0 1 1 8.4 20.039 16.915 16.915 0 0 0 11 11a1 1 0 0 1 1-1Zm3.443 6.038a1 1 0 0 1 .69 1.234 22.876 22.876 0 0 1-1.56 4.02 1 1 0 1 1-1.788-.896 20.882 20.882 0 0 0 1.424-3.668 1 1 0 0 1 1.234-.69Z"
				clipRule="evenodd"
			/>
		</svg>
	)
}
